"use strict";

var _interopRequireDefault = require("/var/www/html/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.sort");
require("core-js/modules/es6.function.name");
var _recommended = require("@/api/recommended");
var _imageUpload = _interopRequireDefault(require("@/components/image-upload"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  components: {
    ImageUpload: _imageUpload.default
  },
  props: {
    manageType: {
      type: String,
      default: ''
    },
    ruleForm: {
      id: -1,
      url: '',
      name: '',
      desc: '',
      sequence: '',
      people: '',
      status: ''
    },
    selectedCateId: {
      type: String,
      default: ''
    },
    channel: {
      type: String,
      default: ''
    },
    selectedPage: {
      type: String,
      default: ''
    },
    allProductList: {
      type: Array | String,
      default: function _default() {
        return '';
      }
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      listData: {
        id: '',
        url: '',
        name: '',
        desc: '',
        sequence: '',
        people: 0,
        // 测过人数
        status: 'disable'
      },
      iconUrl: {
        img_url: ''
      },
      bannerUrl: {
        img_url: ''
      },
      bannerLongUrl: {
        img_url: ''
      },
      rules: {
        app_id: {
          required: false,
          message: '请选择所属产品app_id',
          trigger: 'blur'
        },
        url: {
          required: true,
          message: '请输入测算链接',
          trigger: 'blur'
        },
        name: {
          required: true,
          message: '请输入测算标题',
          trigger: 'blur'
        },
        desc: {
          required: true,
          message: '请输入文案',
          trigger: 'blur'
        },
        sequence: {
          required: true,
          message: '请输入排序',
          trigger: 'blur'
        },
        people: {
          required: true,
          message: '请输入测评人数',
          trigger: 'blur'
        },
        status: {
          required: false,
          message: '请选择上架状态',
          trigger: 'blur'
        }
      },
      statusData: [{
        value: '启用',
        label: 'enable'
      }, {
        value: '禁用',
        label: 'disable'
      }]
    };
  },
  watch: {
    ruleForm: function ruleForm(value) {
      var app_id = value.app_id,
        id = value.id,
        url = value.url,
        name = value.name,
        desc = value.desc,
        sort = value.sort,
        people = value.people,
        status = value.status,
        icon = value.icon,
        banner = value.banner,
        banner_long = value.banner_long;
      if (this.manageType === 'edit') {
        this.rules.status.required = true;
      }
      var obj = {
        app_id: app_id,
        id: id,
        url: url,
        name: name,
        desc: desc,
        sequence: sort,
        people: people,
        status: status
      };
      this.listData = obj;
      this.iconUrl.img_url = icon;
      this.bannerUrl.img_url = banner;
      this.bannerLongUrl.img_url = banner_long;
    }
  },
  methods: {
    onCancel: function onCancel() {
      this.dialogVisible = false;
    },
    submitForm: function submitForm(formName) {
      var _this = this;
      var iconUrlUpload = this.$refs.iconUrlUpload.validateData();
      var bannerUrlUpload = this.$refs.bannerUrlUpload.validateData();
      var bannerLongUrlUpload = this.$refs.bannerLongUrlUpload.validateData();
      var imgFlag = iconUrlUpload && bannerUrlUpload && bannerLongUrlUpload;
      this.$refs[formName].validate(function (valid) {
        if (valid && imgFlag) {
          _this.handleEvent();
        } else {
          return false;
        }
      });
    },
    handleEvent: function handleEvent() {
      var _this2 = this;
      var _this$listData = this.listData,
        app_id = _this$listData.app_id,
        id = _this$listData.id,
        name = _this$listData.name,
        desc = _this$listData.desc,
        url = _this$listData.url,
        sequence = _this$listData.sequence,
        people = _this$listData.people,
        status = _this$listData.status;
      var req = {
        app_id: app_id,
        name: name,
        desc: desc,
        url: url,
        sort: sequence,
        people: people,
        icon: this.iconUrl.img_url,
        banner: this.bannerUrl.img_url,
        banner_long: this.bannerLongUrl.img_url
      };
      var isAdd = this.manageType === 'add';
      if (isAdd) {
        req.cate_id = this.selectedCateId;
        req.channel = this.channel;
      } else {
        req.status = status;
      }
      var connector = isAdd ? (0, _recommended.addSiteResource)(req) : (0, _recommended.editSiteResource)(id, req);
      connector.then(function (_ref) {
        var code = _ref.code,
          msg = _ref.msg;
        if (code === 200) {
          _this2.$message({
            message: msg,
            type: 'success'
          });
          _this2.dialogVisible = false;
          _this2.$parent.getList(); // 更新父组件数据
        }
      }).catch();
    }
  }
};